import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class CartaPorteCatalogoManager {

  static __values = {};

  static async boot()
  {
    let value = await Storage.get('catalogo.cartaporte');

    const params = {
      name: 'c_cp',
      version: !!value ? value.version : '0'
    }

    let response = {};

    try {
      response = await Http.get('/api/catalogos/grupos', { params });

      if (!!response.data && response.data.length > 0) {
        value = {
          'version': response.data[0].version,
          'data': response.data
        };

        await Storage.put('catalogo.cartaporte', value);
      }

      if (!!value) {
        for (const item of value.data) {
          CartaPorteCatalogoManager.__values[item.name] = item.values;
        }
      }
    } catch (error) {
      throw new Error('Los catálogos de CartaPorte no están disponibles');
    }
  }

  static get(catalog, _default = null) {
    return CartaPorteCatalogoManager.__values[catalog] || _default;
  }

  static all() {
    return CartaPorteCatalogoManager.__values;
  }
}

export default CartaPorteCatalogoManager;